var exports = {
  "m": "xaf9ae18d--cd8be0--mobile-banner",
};

module.exports = exports;
